import { Meteor } from 'meteor/meteor';
import { ValidatedMethod } from 'meteor/mdg:validated-method';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';
import { DDPRateLimiter } from 'meteor/ddp-rate-limiter';
import _ from 'lodash';

import moment from 'moment';

import { Reservations } from './reservations';
import { Flights } from '../flights/flights';

import { getAvailabilityCount } from '../../helpers/availabilities';

export const scheduleReservation = new ValidatedMethod({
	name: 'reservations.schedule',
	validate: new SimpleSchema({
		_id: { type: String },
		date: { type: Date },
		place: { type: String, allowedValues: ["anjou", "nantes"] },
		period: { type: String, allowedValues: ["morning", "evening"] },
	}).validator(),
	run({ _id, date, place, period }) {
		let reservation = Reservations.findOne(_id);
		let userId = Meteor.userId();
		if (!reservation)
			throw new Meteor.Error('reservation_not_found',
										'La réservation n\'existe plus en base de donnée');

		//if (Flights.findOne({reservationIds: { $in: [reservation._id] }, status: { $ne: "cancelled" }}) OR )
		//	throw new Meteor.Error('already_prepared',
		//								'Cette réservation a déjà été attaché à un vol');

		if (reservation.passengers.length > getAvailabilityCount(date, place, period))
			throw new Meteor.Error('not_enough_availability',
										'Il n\'y pas suffisament de place sur ce créneau pour cette réservation');

		// TODO : Vérifier si la reservation est bien possible selon les poids et la repartition dans les montgolfieres

		let historyItem = {
			type: "scheduled",
			date: new Date(),
			'scheduledAt': moment(date).startOf('day').toDate(),
			place,
			period,
			userId
		};

		Reservations.update(_id, {
			$set: {
				'scheduledAt': moment(date).startOf('day').toDate(),
				place,
				'periodTime': period
			},
			$push: {
				history: historyItem
			}
		});

		return true;
	}
});

export const getBilletID = new ValidatedMethod({
	name: 'reservations.getBilletID',
	validate: new SimpleSchema().validator(),
	run() {

		if (this.isSimulation) {
			console.log('client side');
			return;
		} else {
			console.log('server side');

			let d = new Date();
			let reservations = Reservations.find({id_billet: {$regex: ".*" + d.getFullYear().toString().slice(-2) + "-.*"}}, {sort: {id_billet: -1}}).fetch();

			let bigger = 0;

			_.each(reservations, (reservation) => {
				let numerotation = reservation.id_billet.replace(d.getFullYear().toString().slice(-2) + '-', '');
				if(numerotation > bigger) {
					bigger = parseInt(numerotation);
				}
			});

			let total = bigger + 1;

			console.log('total', total);

			let numerotation = '';
			for(let i = 0; i < (4 - total.toString().length); i++) {
				numerotation += '0';
			}

			console.log(d.getFullYear().toString().slice(-2) + '-' + numerotation + total);

			return d.getFullYear().toString().slice(-2) + '-' + numerotation + total;

		}
	}});

// Get list of all method names on Lists
const LISTS_METHODS = _.map([
	scheduleReservation,
	getBilletID
], 'name');

if (Meteor.isServer) {
  // Only allow 5 list operations per connection per second
  DDPRateLimiter.addRule({
    name(name) {
      return _.includes(LISTS_METHODS, name);
    },

    // Rate limit per connection ID
    connectionId() { return true; },
  }, 5, 1000);
}



/** WEBPACK FOOTER **
 ** ./src/universal/collections/reservations/methods.js
 **/